const Map = () => {
  return (
    <div className="iframe">
      <iframe
        title={"map"}
        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d202.25137396263227!2d51.44887089099617!3d35.799393633494084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sde!4v1709381134877!5m2!1sen!2sde"
      ></iframe>
    </div>
  );
};
export default Map;
